import type { PocInputValidity } from 'commons/types';
import { useState } from 'react';
import { VALID_STATUS_TRACKING_STATE } from '../../constants';
import { areSectionsValidExcept } from './configuration-status-tracking.validation';
import {
    DeviceSettingsGeneralConfigurationFormValidation,
    DeviceSettingsGeneralConfigurationFormValidationKeys,
} from './configuration-status-tracking.validation.type';

export const useConfigurationStatusTrackingFormValidation = () => {
    const [formValidation, setFormValidation] = useState<DeviceSettingsGeneralConfigurationFormValidation>({
        connectivityProperties: VALID_STATUS_TRACKING_STATE,
        qcProperties: VALID_STATUS_TRACKING_STATE,
        cleaningProperties: VALID_STATUS_TRACKING_STATE,
    });

    const handleValidityChange = (
        key: DeviceSettingsGeneralConfigurationFormValidationKeys,
        sectionValidity: PocInputValidity
    ) => {
        setFormValidation((prev) =>
            prev[key].state === sectionValidity.state ? prev : { ...prev, [key]: sectionValidity }
        );
    };

    const areOtherSectionsValid = (changedKey: DeviceSettingsGeneralConfigurationFormValidationKeys) =>
        areSectionsValidExcept(formValidation, changedKey);

    return { areOtherSectionsValid, handleValidityChange };
};
